const languages = Object.freeze(
  [{ id: 1, name: 'EN' }, { id: 2, name: 'DE' }, { id: 3, name: 'CS' }, { id: 4, name: 'ES' }, { id: 5, name: 'NL' }].map(
    tentacle => Object.freeze(tentacle)
  )
);

export default languages;
